module.exports = __webpack_public_path__ + "static/media/mem3.ce658070.jpg";